import { render, staticRenderFns } from "./Tea.vue?vue&type=template&id=522d8540&scoped=true&"
import script from "./Tea.vue?vue&type=script&lang=js&"
export * from "./Tea.vue?vue&type=script&lang=js&"
import style0 from "./Tea.vue?vue&type=style&index=0&id=522d8540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d8540",
  null
  
)

export default component.exports